import React, { useEffect, useState } from "react";
import { Col, Container, Form, Label, Row, FormGroup } from "reactstrap";;
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import 'react-phone-number-input/style.css';
import { countryOptionss, OperatorOptionsFields, OperatorStatusOptions } from "../OperatorManagement/Constant/Options";
import { fetchOperatorbyId } from "../../slices/OperatorManagement/GetOperatorbyID/thunk";

export default function BusinessDetails() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const [editData, setEditData] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [fileSelected, setFileSelected] = useState(false);
    const changePassword = location?.state?.changePassword || false;
    const [changePasswordStatus, setChangePasswordStatus] = useState(false);
    const [loading, setLoading] = useState()
    const profile = location.pathname.includes('profile-operator')
    const operatorId = localStorage.getItem('operatorId')
    const profilee = []
    const [update, setUpdate] = useState(!!profilee);

    const initialValues = {
        businessName: "",
        Domain: "",
        state: "",
        city: "",
        zipCode: "",
        endDate: null,
        Address: "",
        Address2: "",
        country: "",
        firstname: "",
        lastname: "",
        username: "",
        phone: "",
        email: "",
        Status: "",
        isSSOUser: false,
        // attributeList: []
    };
    const operatorOptions = [
        {
            name: "Domain",
            value: "Operator",
            options: OperatorOptionsFields
        },
        {
            name: "country",
            value: "Operator",
            options: countryOptionss
        },
        {
            name: "Status",
            value: "Operator",
            options: OperatorStatusOptions
        }
    ]

    useEffect(() => {
        dispatch(fetchOperatorbyId(setLoading, operatorId, initialValues, operatorOptions, OperatorStatusOptions, setEditData));
    }, [dispatch])

    const operatorData = useSelector((state) => state?.GetOperator?.GetOperatorId ?? null);

    const operatorDetails = [
        { label: "Business Name", value: operatorData?.tradingName },
        { label: "Domain", value: operatorData?.domain },
        { label: "End Date", value: operatorData?.existsDuring?.endDateTime },
        { label: "Address", value: operatorData?.street1 },
        { label: "Address 2", value: operatorData?.street2 },
        { label: "Country", value: operatorData?.country || '' },
        { label: "State", value: operatorData?.state },
        { label: "City", value: operatorData?.city },
        { label: "Zip Code", value: operatorData?.postcode },
    ];
    function formatUTCDateString(dateStr) {
        const date = new Date(dateStr);

        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', {
            month: 'short',
            timeZone: 'UTC'
        });
        const year = date.getUTCFullYear();

        let hour = date.getUTCHours();
        const minute = String(date.getUTCMinutes()).padStart(2, '0');
        const ampm = hour >= 12 ? 'pm' : 'am';

        hour = hour % 12 || 12;
        const formattedHour = String(hour).padStart(2, '0');

        return `${day} ${month} ${year}, ${formattedHour}.${minute} ${ampm}`;
    }



    return (
        <div>
            <Row className="gy-4 py-4">
                <h5 className="rv-page-title border-bottom py-3">Business Details</h5>
                {operatorDetails.map((detail, index) => (
                    <Col xs={12} md={index === 0 ? 12 : 6} lg={index === 0 ? 12 : 6} key={index} className='border-bottom'>
                        <FormGroup>
                            <p className="fw-semibold fs-14">{detail.label}</p>
                            {(detail.label == "End Date") ?
                                <p className='mb-0'>{detail.value && detail.value.length > 0 ? formatUTCDateString(detail.value) : "-"}</p>
                                :
                                <p className='mb-0'>{detail.value && detail.value.length > 0 ? detail.value : "-"}</p>
                            }

                        </FormGroup>

                    </Col>
                ))}
            </Row>
        </div>
    )

}